import React from 'react'
import DataGrid from './DataGrid'

const WrapDataGrid = (props) => <DataGrid {...props} permissionHOC="gridColumn" />
export default WrapDataGrid 